import { Button, Form } from 'devextreme-react';
import React, { forwardRef, ReactElement,  useState } from 'react';
import { AccountDocument } from '../../../types';
import {
    RequiredRule,
    GroupItem,
    SimpleItem,
} from "devextreme-react/form";
import { useSelector } from 'react-redux';
import { getLocalized } from '../../../../../redux/localization';
import { ILookupOptions } from 'devextreme-react/lookup';
import { FileUploader } from '../../../../../components';

export const renderInformationItem = (item: any) => {
    if (item.editorOptions.value !== null) {
        return <span>{item.editorOptions.value}</span>;
    } else {
        return <span>-</span>;
    }
};

const CreateDocumentForm = forwardRef<any, { data: AccountDocument, lookup?: any }>(
    ({ data, lookup }, ref) => {

        const localize = useSelector(getLocalized);
        const [components, setComponents] = useState<ReactElement[]>();
    
        const onClick = () => {
            const length = components ? components.length + 1 : 1;

            setComponents(
                components
                    ? [
                        ...components,
                        <GroupItem colCount={2}>
                            <SimpleItem
                                dataField={`AccountDocuments[${length}].DocumentTypeId`}
                                label={{
                                    text: "Doküman Tipi",
                                }}
                                editorType={"dxLookup"}
                                editorOptions={
                                    {
                                        searchEnabled: true,
                                        items: lookup,
                                        displayExpr: "Name",
                                        valueExpr: "Id",
                                    } as ILookupOptions
                                }
                            >
                                <RequiredRule message={localize.getString("required")} />
                            </SimpleItem>

                            <SimpleItem
                                dataField={`AccountDocuments[${length}].Document`}
                                label={{
                                    text: localize.getString("small_image"),
                                }}
                            >
                                <FileUploader
                                    buttonText={localize.getString("select_logo")}
                                    onValueChanged={(values) => (data.AccountDocuments[length].Document = values[0])}
                                />
                                <RequiredRule message={localize.getString("required")} />
                            </SimpleItem>
                        </GroupItem>,
                    ]
                    : [
                        <GroupItem colCount={2}>
                            <SimpleItem
                                dataField={`AccountDocuments[${length}].DocumentTypeId`}
                                label={{
                                    text: "Doküman Tipi",
                                }}
                                editorType={"dxLookup"}
                                editorOptions={
                                    {
                                        searchEnabled: true,
                                        items: lookup,
                                        displayExpr: "Name",
                                        valueExpr: "Id",
                                    } as ILookupOptions
                                }
                            >
                                <RequiredRule message={localize.getString("required")} />
                            </SimpleItem>

                            <SimpleItem
                                dataField={`AccountDocuments[${length}].Document`}
                                label={{
                                    text: localize.getString("accountdocuments")
                                }}
                            >
                                <FileUploader
                                    buttonText={localize.getString("select_logo")}
                                    onValueChanged={(values) => {
                                        (data.AccountDocuments[length].Document = values[0])
                                    }}
                                />
                                <RequiredRule message={localize.getString("required")} />
                            </SimpleItem>
                        </GroupItem>,
                    ]
            );
        };
        return (
            <form>     
                <Form
                    ref={ref}
                    key="id"
                    labelLocation="left"
                    formData={data}
                    showColonAfterLabel={true}
                    validationGroup='createdocumentFormValidation'
                >
                    <GroupItem colCount={3}>
                        <SimpleItem
                            dataField={"AccountDocuments[0].DocumentTypeId"}
                            label={{
                                text: localize.getString("documentType"),
                            }}
                            editorType={"dxLookup"}
                            editorOptions={
                                {
                                    searchEnabled: true,
                                    items: lookup,
                                    displayExpr: "Name",
                                    valueExpr: "Id",
                                    
                                } as ILookupOptions
                            }
                        >
                        </SimpleItem> 
                        <SimpleItem
                            dataField={`AccountDocuments[0].Document`}
                            label={{
                                text: localize.getString("accountdocuments")
                            }}
                        >
                            <FileUploader
                                buttonText={localize.getString("selectFile")}
                                onValueChanged={(values) => (data.AccountDocuments[0].Document = values[0])}
                            />
                            <RequiredRule message={localize.getString("required")} />
                        </SimpleItem>
                        <SimpleItem>
                            <Button
                                className="datagrid-action-button"
                                icon="add"
                                type="success"
                                stylingMode="contained"
                                onClick={() => onClick()}
                            />
                        </SimpleItem>
                    </GroupItem>
                    {components}
                </Form>
            </form>
        );
    }
);


export default CreateDocumentForm;
